import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { heroImages } from "../data/mock";
import { Eyebrow, CTASection } from "../components/common";
import { Button } from "../components/ui/button";
import api from "../lib/api";
import Seo from "../components/Seo";
import { CalendarDays, ArrowLeft, Loader2 } from "lucide-react";

const fmt = (d) => new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);
  const [more, setMore] = useState([]);
  useEffect(() => {
    api.getPost(slug).then(setPost).catch(() => setPost(null));
    api.getBlog().then((all) => setMore(all.filter((p) => p.slug !== slug).slice(0, 2))).catch(() => {});
  }, [slug]);

  if (post === undefined) return (<div className="flex justify-center py-40"><Loader2 className="h-8 w-8 animate-spin text-[#f5a524]" /></div>);
  if (post === null) return (<div className="container-x py-40 text-center"><h1 className="font-display text-4xl text-white">Post not found</h1><Link to="/blog" className="text-[#f5a524] mt-4 inline-block">Back to journal</Link></div>);
  return (
    <>
      <Seo
        title={`${post.title} | Hog Tide Fishing Blog`}
        description={post.meta_description || post.excerpt}
        path={`/blog/${post.slug}`}
        image={post.cover}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: post.title,
          description: post.excerpt,
          image: post.cover,
          datePublished: post.created_at,
          author: { "@type": "Organization", name: post.author || "Hog Tide Fishing" },
          publisher: { "@type": "Organization", name: "Hog Tide Fishing" },
          mainEntityOfPage: `https://hogtidefishing.com/blog/${post.slug}`,
        }}
      />
      <section className="relative min-h-[50vh] flex items-end overflow-hidden">
        <img src={post.cover} alt={post.title} className="absolute inset-0 h-full w-full object-cover animate-kenburns" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f33] via-[#0a1f33]/60 to-transparent" />
        <div className="container-x relative z-10 pb-10 pt-28 max-w-3xl">
          <Link to="/blog" className="inline-flex items-center gap-1 text-slate-300 hover:text-[#f5a524] text-sm mb-3"><ArrowLeft className="h-4 w-4" /> Journal</Link>
          <Eyebrow>{post.tag}</Eyebrow>
          <h1 className="font-display text-4xl md:text-5xl text-white text-shadow-hero">{post.title}</h1>
          <p className="text-slate-300 text-sm mt-3 flex items-center gap-1"><CalendarDays className="h-4 w-4" /> {fmt(post.created_at)} · {post.author}</p>
        </div>
      </section>
      <section className="py-14">
        <div className="container-x max-w-3xl">
          {post.body.map((para, i) => (<p key={i} className="text-slate-200 leading-relaxed text-lg mb-5">{para}</p>))}
          <div className="rounded-2xl border border-[#f5a524]/30 bg-[#0e2740] p-6 mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div><h3 className="font-heading text-2xl text-white">Ready to hit the water?</h3><p className="text-slate-300 text-sm">Book a private Hog Tide charter in San Juan del Sur.</p></div>
            <Link to="/plan-your-trip"><Button className="btn-gold h-12 px-7">Plan Your Trip</Button></Link>
          </div>
        </div>
      </section>
      <section className="py-6">
        <div className="container-x max-w-3xl">
          <h3 className="font-heading text-2xl text-white mb-5">Keep reading</h3>
          <div className="grid sm:grid-cols-2 gap-5">
            {more.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="card-hover group rounded-xl overflow-hidden relative h-44 border border-white/10 block">
                <img src={p.cover} alt={p.title} className="absolute inset-0 h-full w-full object-cover transition group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f33] to-transparent" />
                <span className="absolute bottom-3 left-3 right-3 font-heading text-lg text-white">{p.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTASection image={heroImages[2].img} />
    </>
  );
};

export default BlogPost;
